import { createAccessControl } from "better-auth/plugins/access";
import { defaultStatements, adminAc, ownerAc, memberAc } from "better-auth/plugins/organization/access";

export const statement = {
  ...defaultStatements,
  project: ["create", "list", "update", "delete", "toggleSpotlight"],
} as const;

export const ac = createAccessControl(statement);

export const owner = ac.newRole({
  ...ownerAc.statements,
  project: ["create", "list", "update", "delete", "toggleSpotlight"],
});

export const admin = ac.newRole({
  ...adminAc.statements,
  project: ["create", "list", "update", "delete", "toggleSpotlight"],
});

export const member = ac.newRole({
  ...memberAc.statements,
  project: [],
});

export const roles = { owner, admin, member };
